import { IOnInit } from 'angular';
import * as angular from 'angular';
import { FeeType, FeeTier } from '@models/fees/fee.models';

class FeeTypeFormController implements IOnInit {

  public feeType: FeeType;
  public onValidChange: (args: { isValid: boolean }) => void;
  public feeTypeInnerForm: ng.IFormController;

  /** @ngInject */
  constructor(private $scope: angular.IScope, private $timeout: angular.ITimeoutService) {}

  $onInit() {
    // The backend uses high=0 as a sentinel for "no upper limit" on the last tier.
    // Convert to null so the field renders empty and skips the min validator.
    // The save path already converts null back to 0 before sending to the backend.
    this.normalizeLastTierHigh();

    // Notify parent whenever form validity changes so it can gate its Save button
    this.$timeout(() => {
      this.$scope.$watch(
        () => this.feeTypeInnerForm && this.feeTypeInnerForm.$valid,
        (isValid: boolean) => {
          if (this.onValidChange) {
            this.onValidChange({ isValid: !!isValid });
          }
        }
      );
    }, 0);
  }

  private normalizeLastTierHigh() {
    if (!this.feeType || !this.feeType.isTiered || !this.feeType.feeTiers || this.feeType.feeTiers.length === 0) {
      return;
    }
    const lastTier = this.feeType.feeTiers[this.feeType.feeTiers.length - 1];
    if (lastTier.high === 0) {
      lastTier.high = null;
    }
  }

  getNewFeeTier = (prevFeeTier?: FeeTier): FeeTier => {
    const feeTier: FeeTier = { id: 0, high: null, low: 0, value: null };
    if (prevFeeTier) feeTier.low = prevFeeTier.high;
    return feeTier;
  }

  addRemoveTiers = () => {
    if (this.feeType.isTiered && (!this.feeType.feeTiers || this.feeType.feeTiers.length === 0)) {
      this.feeType.feeTiers = [this.getNewFeeTier()];
    }
  }

  addFeeTier = () => {
    const prev = this.feeType.feeTiers ? this.feeType.feeTiers[this.feeType.feeTiers.length - 1] : null;
    this.feeType.feeTiers.push(this.getNewFeeTier(prev));
  }

  adjustNextTierLowValue = (currentFeeTier: FeeTier) => {
    const idx = this.feeType.feeTiers.indexOf(currentFeeTier);
    if (idx > -1 && idx < this.feeType.feeTiers.length - 1) {
      this.feeType.feeTiers[idx + 1].low = currentFeeTier.high;
    }
  }

  removeTier = (currentFeeTier: FeeTier) => {
    const idx = this.feeType.feeTiers.indexOf(currentFeeTier);
    if (idx > 0) {
      this.feeType.feeTiers.splice(idx, 1);
      this.adjustNextTierLowValue(this.feeType.feeTiers[idx - 1]);
      this.adjustNextTierLowValue(this.feeType.feeTiers[idx]);
    }
  }

  getFeeTierHighValueLimit = (feeTier: FeeTier) => {
    return (feeTier.low || 0) + 1;
  }

  isHighTierValueRequired = (feeTier: FeeTier) => {
    const idx = this.feeType.feeTiers.indexOf(feeTier);
    return idx !== this.feeType.feeTiers.length - 1;
  }

  enableAddTierButton = () => {
    return this.feeType.feeTiers[this.feeType.feeTiers.length - 1].high;
  }
}

export const feeTypeForm: angular.IComponentOptions = {
  template: require('./feeType.form.html'),
  controller: FeeTypeFormController,
  controllerAs: '$ctrl',
  bindings: {
    feeType: '=',
    onValidChange: '&'
  }
};



// WEBPACK FOOTER //
// ./src/app/fees/feeTypeManagement/feeTypeForm/feeType.form.ts